(() => {
  const sections = document.querySelectorAll('.featured-product-lotus');
  sections.forEach((section) => {
    const radios = section.querySelectorAll('.fp-gallery__radio');
    const thumbs = section.querySelector('[data-fp-thumbs]');
    const prev = section.querySelector('[data-fp-arrow="prev"]');
    const next = section.querySelector('[data-fp-arrow="next"]');

    const getCheckedIndex = () => {
      let idx = 0;
      radios.forEach((r, i) => {
        if (r.checked) idx = i;
      });
      return idx;
    };

    function centerThumbInStrip(thumb) {
      // Rail-local horizontal scroll only — never touches document scrollY.
      if (!thumbs || !thumb) return;
      const tRect = thumb.getBoundingClientRect();
      const rRect = thumbs.getBoundingClientRect();
      const offsetWithin = (tRect.left + tRect.width / 2) - rRect.left;
      const target = thumbs.scrollLeft + offsetWithin - thumbs.clientWidth / 2;
      const max = Math.max(0, thumbs.scrollWidth - thumbs.clientWidth);
      thumbs.scrollTo({ left: Math.max(0, Math.min(target, max)), behavior: 'smooth' });
    }

    // Helper: list of indices that are currently visible (not hidden by the color filter)
    const getVisibleIndices = () =>
      Array.from(radios)
        .map((r, i) => (r.classList.contains('fp-gallery__radio--hidden') ? -1 : i))
        .filter((i) => i !== -1);

    const setIndex = (idx) => {
      if (!radios.length) return;
      // Step through ONLY the currently visible slides (color filter friendly).
      const visible = getVisibleIndices();
      if (!visible.length) return;
      const checkedIdx = getCheckedIndex();
      let pos = visible.indexOf(checkedIdx);
      if (pos === -1) pos = 0;
      const delta = idx - checkedIdx; // -1 or +1 from the arrow / swipe
      const nextPos = ((pos + Math.sign(delta)) % visible.length + visible.length) % visible.length;
      const target = visible[nextPos];
      radios[target].checked = true;
      radios[target].dispatchEvent(new Event('change', { bubbles: true }));
      if (thumbs) centerThumbInStrip(thumbs.children[target]);
    };

    if (prev) prev.addEventListener('click', () => setIndex(getCheckedIndex() - 1));
    if (next) next.addEventListener('click', () => setIndex(getCheckedIndex() + 1));

    // Variant swatch — update the form's variant ID and the price block when a swatch is selected.
    const swatchInputs = section.querySelectorAll('.fp-swatch__input');
    const form = section.querySelector('form[data-type="add-to-cart-form"]');
    const variantInput = form ? form.querySelector('input[name="id"]') : null;
    const selectedLabel = section.querySelector('[data-fp-selected-value]');

    /* "Go straight to checkout" — the product form is a plain {% form 'product' %},
       so a native submit posts to /cart/add and Shopify redirects to the CART page.
       For buttons flagged data-fp-checkout="true" we instead add via AJAX and send the
       shopper straight to /checkout (routing through /discount/CODE when one is set so
       the code is applied). Scoped to this section's form only — other product
       templates keep Dawn's default behaviour. */
    if (form) {
      form.addEventListener('submit', (e) => {
        const btn = e.submitter || form.querySelector('button[name="add"][data-fp-checkout="true"]');
        if (!btn || btn.getAttribute('data-fp-checkout') !== 'true') return; // not a checkout button → native behaviour
        e.preventDefault();
        if (btn.dataset.fpLoading === '1') return;
        btn.dataset.fpLoading = '1';

        const goToCheckout = () => {
          const code = window.LOTUS_DISCOUNT_CODE;
          if (code) {
            window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout'));
          } else {
            window.location.assign('/checkout');
          }
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        })
          .then((r) => (r.ok ? r.json() : Promise.reject(r)))
          .then(goToCheckout)
          .catch(() => {
            // Network/validation failure → fall back to a native submit (adds + shows cart).
            btn.dataset.fpLoading = '';
            form.submit();
          });
      });
    }

    /* Color-tagged gallery filter:
       Each gallery radio / slide / thumb may carry data-fp-color="<value>". When the
       selected swatch (data-fp-swatch-value) matches that value (case-insensitive),
       the slide is shown. Untagged items (data-fp-color="") always show — that's the
       fallback for merchants who don't tie images to specific colors. */
    const slides = section.querySelectorAll('.fp-gallery__slide');
    const thumbList = thumbs ? thumbs.querySelectorAll('.fp-gallery__thumb') : [];
    const hasColorTag = Array.from(radios).some((r) => (r.dataset.fpColor || '').length > 0);
    const testimonial = section.querySelector('.fp-testimonial');

    function syncTestimonial() {
      if (!testimonial) return;
      // Find the index of the first non-hidden radio.
      let firstVisible = -1;
      radios.forEach((r, i) => {
        if (firstVisible === -1 && !r.classList.contains('fp-gallery__radio--hidden')) firstVisible = i;
      });
      // Show the testimonial only if the currently-checked radio is that first visible one.
      const checked = Array.from(radios).findIndex((r) => r.checked);
      const onFirst = firstVisible !== -1 && checked === firstVisible;
      testimonial.classList.toggle('fp-testimonial--hidden', !onFirst);
    }

    function filterGalleryByColor(color) {
      if (!hasColorTag) {
        syncTestimonial();
        return;
      }
      const want = (color || '').toLowerCase().trim();
      let firstVisibleIdx = -1;
      let checkedStillVisible = false;

      radios.forEach((radio, i) => {
        const tag = (radio.dataset.fpColor || '').toLowerCase().trim();
        const show = !tag || tag === want;
        radio.classList.toggle('fp-gallery__radio--hidden', !show);
        const slide = slides[i];
        const thumb = thumbList[i];
        if (slide) slide.classList.toggle('fp-gallery__slide--hidden', !show);
        if (thumb) thumb.classList.toggle('fp-gallery__thumb--hidden', !show);
        if (show) {
          if (firstVisibleIdx === -1) firstVisibleIdx = i;
          if (radio.checked) checkedStillVisible = true;
        }
      });

      if (!checkedStillVisible && firstVisibleIdx !== -1) {
        radios[firstVisibleIdx].checked = true;
        if (thumbs) centerThumbInStrip(thumbList[firstVisibleIdx]);
      }
      syncTestimonial();
    }

    function getSelectedSwatchValue() {
      const checked = section.querySelector('.fp-swatch__input:checked');
      return checked ? (checked.dataset.fpSwatchValue || '') : '';
    }

    // Initial filter (in case a default swatch is preselected) + testimonial state
    filterGalleryByColor(getSelectedSwatchValue());

    // Sync testimonial whenever the user clicks an arrow / thumb / radio
    radios.forEach((r) => r.addEventListener('change', syncTestimonial));

    /* On mobile (<990px) when the customer picks a swatch, auto-scroll the page
       to the gallery so the now-updated image is in view. Desktop already shows
       both columns side-by-side so no scroll is needed. */
    function scrollGalleryIntoViewIfMobile() {
      if (window.matchMedia('(min-width: 990px)').matches) return;
      const main = section.querySelector('.fp-gallery__main') || section.querySelector('.fp-gallery');
      if (!main) return;
      const headerOffset = 90;
      const top = main.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    /* Always reset the gallery to the first visible image when the customer
       changes variant — even if the previously-checked image happens to still
       be visible under the new color filter. Customers expect to see the
       'hero' image of the variant they just picked. */
    function jumpGalleryToFirstVisible() {
      let firstVisible = -1;
      radios.forEach((r, i) => {
        if (firstVisible === -1 && !r.classList.contains('fp-gallery__radio--hidden')) firstVisible = i;
      });
      if (firstVisible === -1) return;
      if (!radios[firstVisible].checked) {
        radios[firstVisible].checked = true;
        radios[firstVisible].dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (thumbs && thumbList[firstVisible]) centerThumbInStrip(thumbList[firstVisible]);
    }

    swatchInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (variantInput && input.dataset.fpSwatchVariant) {
          variantInput.value = input.dataset.fpSwatchVariant;
        }
        if (selectedLabel && input.dataset.fpSwatchValue) {
          selectedLabel.textContent = input.dataset.fpSwatchValue;
        }
        filterGalleryByColor(input.dataset.fpSwatchValue || '');
        jumpGalleryToFirstVisible();
        scrollGalleryIntoViewIfMobile();
      });
    });

    /* === Swipe / drag-to-navigate on the main image (mobile + desktop) ===
       Pointer Events unify touch + mouse. Threshold 40px; when crossed during a
       gesture, the gallery advances by one (next on left swipe, prev on right).
       Vertical scroll is allowed: if |dy| > |dx| at any point, we cancel.
       Native touchstart/touchmove with passive:false intercepts iOS/Android
       edge-swipe-back (which fires below Pointer Events) when the gesture is
       horizontal — so a right-swipe inside the gallery never navigates back. */
    const main = section.querySelector('.fp-gallery__main');
    if (main) {
      main.style.touchAction = 'pan-y'; // allow native vertical scroll, capture horizontal
      main.style.cursor = 'grab';

      let downX = 0, downY = 0, dragging = false, abandoned = false;
      const SWIPE_PX = 40;

      // Native touch listeners — required for preventDefault to actually block
      // the OS-level edge-swipe-back. `passive: false` is essential.
      let tStartX = 0, tStartY = 0, tHorizLocked = false;
      main.addEventListener('touchstart', (e) => {
        if (!e.touches || !e.touches.length) return;
        tStartX = e.touches[0].clientX;
        tStartY = e.touches[0].clientY;
        tHorizLocked = false;
      }, { passive: true });
      main.addEventListener('touchmove', (e) => {
        if (!e.touches || !e.touches.length) return;
        const dx = e.touches[0].clientX - tStartX;
        const dy = e.touches[0].clientY - tStartY;
        // Once we know the gesture is horizontal, lock and prevent default so
        // the browser doesn't trigger edge-swipe-back / page navigation.
        if (!tHorizLocked && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
          tHorizLocked = true;
        }
        if (tHorizLocked) e.preventDefault();
      }, { passive: false });

      main.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        downX = e.clientX;
        downY = e.clientY;
        dragging = true;
        abandoned = false;
        main.style.cursor = 'grabbing';
      });

      main.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - downX;
        const dy = e.clientY - downY;
        if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 12) {
          abandoned = true;
          dragging = false;
          main.style.cursor = 'grab';
          return;
        }
        if (e.pointerType === 'mouse' && Math.abs(dx) > 4) e.preventDefault();
      });

      const release = (e) => {
        if (!dragging && !abandoned) return;
        const wasDragging = dragging;
        dragging = false;
        main.style.cursor = 'grab';
        if (!wasDragging || abandoned) return;
        const dx = e.clientX - downX;
        if (dx <= -SWIPE_PX) setIndex(getCheckedIndex() + 1);
        else if (dx >= SWIPE_PX) setIndex(getCheckedIndex() - 1);
      };
      main.addEventListener('pointerup', release);
      main.addEventListener('pointercancel', () => { dragging = false; abandoned = false; main.style.cursor = 'grab'; });
      main.addEventListener('pointerleave', release);
    }
  });
})();
